import { render, staticRenderFns } from "./CodeOfEthics.vue?vue&type=template&id=beac75ac&scoped=true"
import script from "./CodeOfEthics.vue?vue&type=script&lang=js"
export * from "./CodeOfEthics.vue?vue&type=script&lang=js"
import style0 from "./CodeOfEthics.vue?vue&type=style&index=0&id=beac75ac&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac75ac",
  null
  
)

export default component.exports